<template>
  <div class="main-card">

    <div class="centercard">


      <div class="left">
        <div class="left-top" style="padding-top: 2.5vh;">
          <div class="left-pic"
            style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <img src="./assets/img/FigmaDDSSlicePNGab43d331888b46c6f56c2304d35fc475.png" alt=""
              style="transform: scale(0.9);">
          </div>
          <div class="left-content"
            style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
            <div class="left-content-name" style="font-size: 24px;font-weight:bold;color: #837999; margin-top: 1vh;">
              王生安
              <img style="width: 30px;height: 26px;" src="./assets/img/star.png">
              <img style="width: 30px;height: 26px;" src="./assets/img/chat.png">
            </div>
            <div class="left-content-line">男 | 40岁 | 17年</div>
            <div class="left-content-line">香港大学 | 硕士</div>
            <div class="left-content-line">面试岗位：产品经理</div>
            <div class="left-content-line">TEL：15988889999</div>
            <div class="left-content-line">email：1234567890@qq.com</div>
            <div class="left-content-line" style="display: flex; align-items: center; justify-content: center;cursor:pointer">
              <img src="./assets/img/resume.png" style="width: 20px; height: 24px;" />
              查看简历
            </div>
          </div>
        </div>
        <div class="left-bottom">
          <div class="right-1" ref="rightElement">
            <div class="div13"
              style="font-size: 2vh;font-weight:bold;color: #837999;margin-bottom: -0.5vh;margin-right: 2vh;">评分细则</div>
            <div class="score-panel">
              <!-- 仪表盘容器 -->
              <div ref="gaugeChart" class="gauge-chart"></div>

            </div>
          </div>
          <div class="right-2" style="margin-top: 2.5vh;">


            <div style="
color: #656587;
margin-bottom: 5px;
font-family: 'Afacad-Regular', sans-serif;
font-size: 14px;
font-weight: 400;
display: flex;
width: 10vw;
min-width: 10vw;
max-width: 15vw;
justify-content: space-between;
">

              <img style="" class="noun-action-7220030-1" src="./assets/img/noun-action-7220030-10.png" />
              <p style="margin-left: 25px;">肢体动作</p>
              <p>{{ body_language }}%</p>
            </div>
            <ProgressBar :progress="body_language" />


          </div>
          <div class="right-2">
            <img style="margin-right: 3px;" class="noun-action-7220030-1" src="./assets/img/noun-answer-69059060.png" />

            <div style="
color: #656587;
margin-bottom: 5px;
font-family: 'Afacad-Regular', sans-serif;
font-size: 14px;
font-weight: 400;
display: flex;
width: 10vw;
min-width: 10vw;
max-width: 15vw;
justify-content: space-between;
">
              <p style="margin-left: 25px;">及时回应</p>
              <p>{{ timely_response }}%</p>

            </div>
            <ProgressBar :progress="timely_response" />


          </div>
          <div class="right-2">
            <img style="margin-right: 3px;" class="noun-action-7220030-1"
              src="./assets/img/noun-just-in-time-74155130.png" />

            <div style="
color: #656587;
margin-bottom: 5px;
font-family: 'Afacad-Regular', sans-serif;
font-size: 14px;
font-weight: 400;
display: flex;
width: 10vw;
min-width: 10vw;
max-width: 15vw;
justify-content: space-between;
">
              <p style="margin-left: 25px;">回答内容</p>
              <p>{{ response_content }}%</p>

            </div>
            <ProgressBar :progress="response_content" />


          </div>
          <div class="right-2">
            <img style="margin-right: 3px;" class="noun-action-7220030-1" src="./assets/img/noun-answer-69059060.png" />

            <div style="
color: #656587;
margin-bottom: 5px;
font-family: 'Afacad-Regular', sans-serif;
font-size: 14px;
font-weight: 400;
display: flex;
width: 10vw;
min-width: 10vw;
max-width: 15vw;
justify-content: space-between;
">
              <p style="margin-left: 25px;">面部表情</p>
              <p>{{ facial_expression }}%</p>

            </div>
            <ProgressBar :progress="facial_expression" />


          </div>
          <div class="right-2">
            <img style="margin-right: 3px;" class="noun-action-7220030-1"
              src="./assets/img/noun-expression-69294180.png" />

            <div style="
color: #656587;
margin-bottom: 5px;
font-family: 'Afacad-Regular', sans-serif;
font-size: 14px;
font-weight: 400;
display: flex;
width: 10vw;
min-width: 10vw;
max-width: 15vw;
justify-content: space-between;
">
              <p style="margin-left: 25px;">仪容仪表</p>
              <p>{{ grooming }}%</p>

            </div>
            <ProgressBar :progress="grooming" />


          </div>
          <div class="right-2">
            <img style="margin-right: 3px;" class="noun-action-7220030-1" src="./assets/img/noun-dress-26828480.png" />

            <div style="
color: #656587;
margin-bottom: 5px;
font-family: 'Afacad-Regular', sans-serif;
font-size: 14px;
font-weight: 400;
display: flex;
width: 10vw;
min-width: 10vw;
max-width: 15vw;
justify-content: space-between;
">
              <p style="margin-left: 25px;">面试语气</p>
              <p>{{ interview_tone }}%</p>

            </div>
            <ProgressBar :progress="interview_tone" />


          </div>
        </div>



      </div>
      <div class="center">

        <div style="display: flex; 
            justify-content: space-between; 
            align-items: center;
            margin-top: 2vh;
            gap: 2vw;
            padding: 0 1.5vw;
            max-width: 100%;">
          <!-- 左侧文字 -->
          <span class="interviewresult" style="margin-right: auto;">面试记录</span>

          <!-- 右侧按钮组 -->

        </div>
        <div class="frame-1">
          <img class="vector-1" src="./assets/img/vector-10.svg" />
          <div class="center-result" v-for="(item, index) in questions" :key="index">
            <p class="question0">问题{{ index + 1 }}</p>
            <p class="question1">{{ item.question }}</p>
            <div style="width: 766px;height: 1px;background: rgb(13,153,255);margin-top: 10px;margin-bottom: 10px;">
            </div>

            <p class="answer0">回答</p>
            <p class="answer1">
              {{ item.answer }}
            </p>
            <p class="advice0">面试官建议</p>
            <p class="advice1">{{ item.advice }}</p>

          </div>


        </div>



      </div>

      <div class="right-bottom" :style="rightBottomStyle"></div>
      <!-- 右边 -->
      <div class="right" ref="rightElement" style="overflow: auto;">
        <div class="box_20 flex-col" style="overflow: auto;">
          <div class="group_5 flex-row justify-between">
            <span class="text_36" style="font-weight: bold;">面试过程中截图</span>
            <img class="label_7" referrerpolicy="no-referrer"
              src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG03d8a56fd06ff54d0e0aad3bf4d90ed0.png" />
          </div>
          <div class="group_6 flex-row justify-between">
            <div class="group_4 flex-col"></div>
            <span class="text_37">01:00</span>
          </div>
          <div class="group_7 flex-row justify-between">
            <div class="box_24 flex-col"></div>
            <div class="image-text_16 flex-col justify-between">
              <img class="image_right" referrerpolicy="no-referrer"
                src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG04cecf9b35553561da0cd22e6f63c9cf.png" />
              <span class="text-group_7">02:00</span>
            </div>
          </div>
          <div class="group_8 flex-row justify-between">
            <div class="section_4 flex-col"></div>
            <div class="image-text_17 flex-col justify-between">
              <img class="image_right" referrerpolicy="no-referrer"
                src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG4451a6d67b4c7f214ff6937b76f26cf0.png" />
              <span class="text-group_8">03:00</span>
            </div>
          </div>
          <div class="group_9 flex-row justify-between">
            <div class="block_1 flex-col"></div>
            <div class="image-text_18 flex-col justify-between">
              <img class="image_right" referrerpolicy="no-referrer"
                src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGb7938ef294640819183031f6e108003e.png" />
              <span class="text-group_9">04:00</span>
            </div>
          </div>
          <div class="group_8 flex-row justify-between">
            <img style="margin-left: 0.88vw;" class="image_right" referrerpolicy="no-referrer"
              src="https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG91ac6b62b62b027ca033d2d3da3208d6.png" />
          </div>
        </div>




      </div>
    </div>
    <div class="feedback-modal" v-if="showFeedback" @click.self="showFeedback = false">
      <div class="feedback-container">
        <div class="feedback-title">用户反馈</div>
        <div class="feedback-question">您和面试官的面试过程愉快吗？</div>

        <div class="emoji-container">
          <div v-for="(emoji, index) in emojis" :key="index" class="emoji-item"
            :class="{ 'selected': selectedEmoji === index }" @click="selectEmoji(index)">
            <img :src="selectedEmoji === index ? emoji.colorUrl : emoji.grayUrl" :alt="emoji.name"
              class="emoji-image" />
          </div>
        </div>

        <div class="feedback-hint">欢迎说说您的想法，面试官会努力做更好！</div>

        <textarea class="feedback-textarea" placeholder="您的意见对我们很重要，请告诉我们您的想法" v-model="feedbackText"></textarea>

        <div class="feedback-buttons">
          <button class="submit-btn" @click="submitFeedback">提交</button>
          <button class="cancel-btn" @click="showFeedback = false">以后再说</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./assets/index.css";
import "./assets/vars.css";
import * as echarts from 'echarts';
import ProgressBar from '@/components/Progress/index.vue'; //
export default {
  components: {
    ProgressBar
  },

  data() {
    return {
      rightBottomStyle: {
        width: '0px',
        height: '0px',
        borderRadius: '0px'
      },
      nickname: '',
      body_language: 0,
      facial_expression: 0,
      grooming: 0,
      interview_tone: 0,
      timely_response: 0,
      response_content: 0,
      progress: 50,
      showPanel: false,
      showFeedback: false,
      selectedEmoji: null,
      feedbackText: '',
      emojis: [
        {
          name: '非常满意',
          grayUrl: require('@/components/SideBar/assets/img/5-gray.png'),  // 需要您提供灰色版本
          colorUrl: require('@/components/SideBar/assets/img/5-light.png') // 需要您提供彩色版本
        },
        {
          name: '满意',
          grayUrl: require('@/components/SideBar/assets/img/4-2x.png'),
          colorUrl: require('@/components/SideBar/assets/img/4-light2x.png')
        },
        {
          name: '一般',
          grayUrl: require('@/components/SideBar/assets/img/3-gray.png'),
          colorUrl: require('@/components/SideBar/assets/img/3-light.png')
        },
        {
          name: '不满意',
          grayUrl: require('@/components/SideBar/assets/img/2-gray.png'),
          colorUrl: require('@/components/SideBar/assets/img/2-light.png')
        },
        {
          name: '非常不满意',
          grayUrl: require('@/components/SideBar/assets/img/1-gray.png'),
          colorUrl: require('@/components/SideBar/assets/img/1-light.png')
        }
      ],
      cards1: [
        {
          image: "img1.png",
          title: "一个产品经理的科普视频...做产品是需要天赋的",
          likes: 1303,
          stars: 2303,
          link: "https://www.bilibili.com/video/BV1Mm4y1Z7En/?spm_id_from=333.337.search-card.all.click"
        },
        {
          image: "img2.png",
          title: "投资是怎样赚钱的，什么是正确的投资方法",
          likes: 22303,
          stars: 12303,
          link: "https://www.bilibili.com/festival/jzj2023?bvid=BV1e8411B7w7&spm_id_from=333.337.search-card.all.click"
        }
      ],
      cards2: [
        {
          image: "image4.png",
          title: "如何成长为一个“懂”AI的产品经理？",
          link: "https://www.zhihu.com/question/648371951/answer/3557122049"
        },
        {
          image: "c1.png",
          title: "哪三本书是产品经理必读书？为什么？",
          link: "https://www.zhihu.com/question/20752514/answer/1984035510"
        },
        {
          image: "c2.png",
          title: "ai产品经理需要哪些必备技能？如何成为ai产品经理？",
          link: "https://www.zhihu.com/question/57815929/answer/1730120649"
        }
      ],
      questions: [
        {
          question: "同学你好，先介绍一下你自己",
          answer: "尊敬的面试官，您好!我叫肖伟。非常荣幸能够参加今天的面试。我毕业于上海交大，所学专业是数字媒体艺术。在大学期间，我不仅努力学习专业知识，还积极参加各种社团活动和实践项目，这极大地锻炼了我的团队协作能力和沟通能力。",
          advice: "缺少工作经历或实习经历的介绍。"
        },
        {
          question: "为什么选择我们公司？",
          answer: "因为贵公司在行业内有很高的知名度...",
          advice: "需要更具体的公司业务关联"
        },
        {
          question: "你的职业规划是什么？",
          answer: "希望在未来三年内成长为专业领域的专家...",
          advice: "建议增加短期目标描述"
        }
      ],
      gaugeChart: null // 图表实例
    }
  },
  mounted() {
    this.getnickname()
    /* while (this.questions.length > 0) { this.questions.pop() } */
    const dialogues = this.$store.state.interviewState.dialogues
    for (let i = 0; i < dialogues.length; i += 3) {
      const question = {
        question: dialogues[i],
        answer: dialogues[i + 1],
        advice: dialogues[i + 2]
      }
      this.questions.push(question)
    }
    /*  this.response_content = this.$store.state.interviewState.content
     this.body_language = this.$store.state.interviewState.body_language
     this.facial_expression = this.$store.state.interviewState.facial_expression
     this.grooming = this.$store.state.interviewState.grooming
     this.interview_tone = this.$store.state.interviewState.interview_tone
     this.timely_response = this.$store.state.interviewState.timely_response
     const score = this.$store.state.interviewState.interviewScore */
    this.response_content = this.$store.state.i
    this.body_language = this.$store.state.intervi
    this.facial_expression = this.$store.state.interviewSt
    this.grooming = this.$store.state.in
    this.interview_tone = this.$store.state.intervie
    this.timely_response = this.$store.state.interviewState.timely_response
    const score = this.$store.state.intervie
    this.initGaugeChart(score);
    window.addEventListener('resize', this.handleChartResize);
    this.$nextTick(() => {
      this.getRightElement()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleChartResize);
    if (this.gaugeChart) {
      this.gaugeChart.dispose();
    }
  },
  methods: {
    navigateToProfile() {
      this.$router.push('/store/dashboard/profile');
    },
    getnickname() {
      let nickname = JSON.parse(localStorage.getItem('userInfo')).nickname;
      if (nickname) {
        this.nickname = nickname;
      }
    },
    getRightElement() {
      const rightElement = this.$refs.rightElement;
      if (rightElement) {
        const width = rightElement.clientWidth;
        const height = rightElement.clientHeight;

        const computedStyle = window.getComputedStyle(rightElement);
        const borderRadius = computedStyle.borderRadius;
        const borderWidth = computedStyle.borderWidth;

        console.log('right元素宽度:', width, 'px');
        console.log('right元素高度:', height, 'px');
        console.log('right元素圆角:', borderRadius);
        console.log('right元素边框宽度:', borderWidth);

        return {
          width,
          height,
          borderRadius,
          borderWidth
        }
      }
    },
    // 初始化仪表盘
    initGaugeChart(score) {
      const dom = this.$refs.gaugeChart;
      this.gaugeChart = echarts.init(dom);

      const option = {
        series: [{
          type: 'pie',
          radius: ['70%', '90%'],
          /*     startAngle: 225,
              endAngle: -45, */
          clockwise: false,
          itemStyle: {
            color: '#F3F4F7' // 将默认颜色设为背景色
          },
          label: {
            position: 'center',
            rich: {
              value: { fontSize: 28, fontWeight: 'bold', color: '#1F2937' },
              title: { fontSize: 14, color: '#6B7280' }
            },
            formatter: `{value|` + score + `}\n{title|总分}` // 直接显示固定值更稳定
          },
          data: [
            // 正确顺序：先背景后进度
            {
              value: 100 - score,  // 背景部分 = 100 - 95
              itemStyle: { color: '#F3F4F7' } // 灰色背景
            },
            {
              value: score, // 进度部分
              itemStyle: { color: '#8B5CF6' }, // 紫色进度
              label: { show: false } // 隐藏进度部分的标签
            }
          ]
        }]
      };

      this.gaugeChart.setOption(option);
    },
    // 响应式调整
    handleChartResize() {
      if (this.gaugeChart) {
        this.gaugeChart.resize();
      }
    },
    exportInterview() {
      //做测试
      this.progress++ > 100 ? 100 : this.progress;

      console.log("导出面试");
    },
    gotomianshilishi() {
      this.$router.push('/interview_mianshilishi')
      setTimeout(() => {
        window.location.reload();
      }, 50);
    },
    selectEmoji(index) {
      this.selectedEmoji = index;
    },
    submitFeedback() {
      // 处理提交反馈的逻辑
      console.log("提交反馈", this.selectedEmoji, this.feedbackText);
      this.showFeedback = false;
    }

  }

};
</script>

<style scoped>
/* * {
  border: 1px solid blue !important;
} */
.left-content-line {
  color: #656587;
  font-family: "Afacad-Regular", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin-top: 0.6vh;
}

.question0 {
  color: #656587;
  font-family: "Afacad-SemiBold", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  margin-top: 20px;
}

.question1 {
  color: #656587;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

.answer0 {
  color: #656587;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
}

.answer1 {
  color: #656587;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

.advice0 {
  color: #656587;
  font-size: 15px;
  font-weight: 600;
  line-height: 2;
}

.advice1 {
  color: #656587;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
}

.score-panel {



  width: 124px;
  height: 131px;

}

.gauge-chart {
  width: 80%;
  height: 80%;
}

.centercard {
  width: 80vw;
  height: 90vh;
  display: flex;

}


.card1 {

  border-radius: 25.92px;

  /* border-style: solid; */
  border-image: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  border-image-slice: 1;
  width: 11vw;
  /* 1920px设计稿基准 */
  min-width: 150px;
  /* 防止过小 */
  max-width: 260px;
  /* 防止过大 */
  height: 9.5vw;
  min-height: 150px;
  /* 防止过小 */
  max-height: 260px;
  /* 防止过大 */

  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(16.2px);
  margin-bottom: 20px;
}

.card2 {
  /*   background: var(--linear,
      linear-gradient(-39.22deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.6) 100%)); */
  border-radius: 25.92px;
  border-width: 1.08px;
  border-image: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  border-image-slice: 1;
  width: 11vw;
  /* 1920px设计稿基准 */
  min-width: 150px;
  /* 防止过小 */
  max-width: 260px;
  /* 防止过大 */
  height: 9.5vw;
  min-height: 150px;
  /* 防止过小 */
  max-height: 260px;
  /* 防止过大 */
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(16.2px);
  margin-bottom: 20px;
}

.center-result {}

.main-card,
.main-card * {
  box-sizing: border-box;
}

.main-card {
  background: #ffffff url("./assets/img/_1-10.png")
    /* 添加背景图片 */
    no-repeat center / cover;
  /* 关键属性 */
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */


}

.like {
  display: flex;
  justify-content: flex-start;
  /* gap: 20px; */
  padding-left: 20px;
  /* 两侧分布 */
  align-items: center;
  /* 垂直居中 */
  width: 100%;
  /* 确保容器有宽度 */
}

.center {
  flex: 0 0 55%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: transparent;
  /* border-radius: 26px 0 0 26px;
  border-width: 1.08px;
  border-image: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  border-image-slice: 1;
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(25.3px); */
  /*   margin-left: -1.5vw;
  border: 1px solid #A47FF6; */
}

.interviewresult {
  background: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0%,
      rgba(177, 110, 249, 1) 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  font-family: "Afacad-Regular", sans-serif;
  font-size: 22px;
  font-weight: 400;
}

.panel {

  border-radius: 24px;
  border-width: 1px;

  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(15px);
  background-color: #fff;
  /*   width: 88px;
  height: 28px; */
  min-width: 88px;
  min-height: 28px;
  width: 5.5vw;
  height: 4vh;



}

.reinterview {
  z-index: 1;
  cursor: pointer;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  /*   bottom: 250px;
  left: 70px; */
  top: 0vh;
  left: 4vw;
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%), linear-gradient(320.78deg, rgba(255, 255, 255, 0) 2.06%, rgba(255, 255, 255, 0.4) 99.08%);
  border-radius: 24px;
  border-width: 1px;
  /* border-style: solid; */
  border-image: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  border-image-slice: 1;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(15px);
  /*   width: 96px;
  height: 33px; */
  min-width: 96px;
  min-height: 33px;
  width: 6.5vw;
  height: 5vh;

}

.cf {
  color: #656587;
  text-align: center;
  font-family: "Afacad-Medium", sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 32px;
}

.right {
  /* 布局属性 */
  flex: 0 0 25%;

  overflow-y: hidden;
  /* 隐藏标准滚动条（Firefox） */
  scrollbar-width: none;
  /* 隐藏滚动条轨道（IE/Edge） */
  -ms-overflow-style: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  /*   background: linear-gradient(180deg,
      rgba(177, 110, 249, 0.1) 0%,
      rgba(126, 180, 235, 0.1) 100%); */
  /*   border-radius: 26px;
  border-width: 1.08px; */
  /* margin-left: -1%; */
  /* border-image: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  border-image-slice: 1;
  box-shadow: 4.32px 4.32px 4.32px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(27.85px); */
  /*   border: 1px solid #A47FF6;
  margin-left: -1.2vw; */
}

/* 自定义滚动条 (保留结构但不可见) */
.right::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.right-1 {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 20%;
  width: 100%;

}

.right-2 {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding-right: 1.3vw;
}

.image-with-text {
  position: relative;
  /* 设置为相对定位，以便子元素可以绝对定位 */
  display: inline-block;
  /* 确保容器只占据必要的空间 */
}


.text-overlay {

  position: absolute;
  width: 80%;
  height: 50%;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* left: calc(50% - 293px/2 + 562.5px);
top: calc(50% - 67px/2 + 83.5px); */

  font-family: 'Afacad';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  /* or 138% */
  display: flex;
  align-items: center;
  text-align: center;

  color: #656587;


}

.image-text-container {
  display: flex;
  /* 使用Flexbox布局 */
  align-items: flex-start;
  /* 垂直居中对齐 */
  gap: 16px;
  /* 图片与文字之间的间距 */
}

p {
  margin: 0;
  /* 移除默认的段落间距 */
}

.panel:hover {
  transform: translateY(-2px);
  /* 悬停微抬升效果 */
}

/* 用户反馈模态框样式 */
.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.feedback-container {
  width: 55vw;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 1.2vw;
  border: 1px solid rgba(177, 110, 249, 0.3);
  box-shadow: 0 0.5vw 2vw rgba(0, 0, 0, 0.1);
  padding: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feedback-title {
  font-size: 2vw;
  font-weight: bold;
  background: linear-gradient(90deg, #B16EF9 0%, #7EB4EB 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 2vh;
  text-align: center;
}

.feedback-question {
  font-size: 1.2vw;
  color: #666;
  margin-bottom: 2vh;
  text-align: center;
}

.emoji-container {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin-bottom: 2vh;
}

.emoji-item {
  width: 4vw;
  height: 4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s;
  position: relative;
  border: 2px solid transparent;
}

.emoji-item.selected {
  border-color: rgba(177, 110, 249, 0.6);
  transform: scale(1.1);
  box-shadow: 0 0 1vw rgba(126, 180, 235, 0.4);
}

.emoji-image {
  width: 3.5vw;
  height: 3.5vw;
  object-fit: contain;
  transition: transform 0.2s;
}

.emoji-item:hover .emoji-image {
  transform: scale(1.1);
}

.feedback-hint {
  font-size: 1vw;
  color: #999;
  margin-bottom: 1.5vh;
  text-align: center;
}

.feedback-textarea {
  width: 80%;
  height: 20vh;
  padding: 1vh 1vw;
  border-radius: 0.8vw;
  border: 1px solid rgba(126, 180, 235, 0.5);
  background: rgba(255, 255, 255, 0.7);
  font-size: 1vw;
  margin-bottom: 2vh;
  resize: none;
  outline: none;
}

.feedback-textarea:focus {
  border-color: rgba(177, 110, 249, 0.7);
  box-shadow: 0 0 0.5vw rgba(126, 180, 235, 0.3);
}

.feedback-buttons {
  display: flex;
  justify-content: space-between;
  width: 60%;
}

.submit-btn,
.cancel-btn {
  width: 10vw;
  height: 8vh;
  border-radius: 2vw;
  font-size: 1vw;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
}

.submit-btn {
  background: linear-gradient(90deg, #7EB4EB, #B16EF9);
  color: white;
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #ddd;
  color: #666;
}

.submit-btn:hover,
.cancel-btn:hover {
  transform: translateY(-0.2vh);
  box-shadow: 0 0.3vh 0.8vh rgba(0, 0, 0, 0.1);
}

/* 分割线 */



.image_1 {
  width: 7.19vw;
  height: 9.48vw;
  margin-left: 3.65vw;
}


.group_5 {
  width: 15.73vw;
  height: 2.09vw;
  margin: 1.04vw 0 0 1.82vw;
}


.text_36 {
  width: 9.28vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-SemiBold Italic;
  font-weight: bold;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.68vw;
}




.label_7 {
  width: 1.36vw;
  height: 1.31vw;
}

.group_6 {
  width: 16.78vw;
  height: 1.41vw;
  margin: 1.45vw 0 0 0.88vw;
}

.group_4 {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 0.53vw;
}

.text_37 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
}

.group_7 {
  width: 16.78vw;
  height: 10.58vw;
  margin: 0.72vw 0 0 0.88vw;
}

.box_24 {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 9.69vw;
}

.image-text_16 {
  width: 15.84vw;
  height: 10.58vw;
}

.image_right {
  width: 14.47vw;
  height: 8.55vw;
  box-sizing: border-box;
  padding-bottom: 1.5vh;
}

.image_2 {
  width: 15.47vw;
  height: 8.55vw;
}

.text-group_7 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.63vw;
}

.group_8 {
  width: 16.78vw;
  height: 10.58vw;
  margin: 0.31vw 0 0 0.88vw;
}

.section_4 {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 9.69vw;
}

.image-text_17 {
  width: 15.84vw;
  height: 10.58vw;
}

.image_3 {
  width: 15.47vw;
  height: 8.55vw;
}

.text-group_8 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.63vw;
}

.group_9 {
  width: 16.78vw;
  height: 10.58vw;
  margin: 0.31vw 0 0vw 0.88vw;
}

.block_1 {
  background-image: linear-gradient(90deg,
      rgba(126, 180, 235, 1) 0,
      rgba(177, 110, 249, 1) 100%);
  border-radius: 50%;
  width: 0.42vw;
  height: 0.42vw;
  margin-top: 9.69vw;
}

.image-text_18 {
  width: 15.84vw;
  height: 10.58vw;
}

.image_4 {
  width: 15.47vw;
  height: 8.55vw;
}

.text-group_9 {
  width: 15.84vw;
  height: 1.41vw;
  overflow-wrap: break-word;
  color: rgba(101, 101, 135, 1);
  font-size: 1.04vw;
  font-family: Afacad-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 1.05vw;
  margin-top: 0.63vw;
}

.image_5 {
  position: absolute;
  left: 3vw;
  top: 39.38vw;
  width: 15.47vw;
  height: 8.55vw;
}
</style>
